import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-buscador-marketplace-tienda',
  templateUrl: './buscador-marketplace.component.html',
  styleUrls: ['./buscador-marketplace.component.scss'],
})

export class BuscadorMarketplaceComponentTienda implements OnInit {
  value:string
  lupaIcon = '/assets/img/icons/ico-lupa-white.svg';
  constructor(private router: Router) {}
  ngOnInit() {}
  async buscar(ev: any, d?) {
    const code = ev.keyCode || ev.which;
    if (code === 13 || d) {
      const query: NavigationExtras = {
        queryParams: {
          search: this.value,
        },
        queryParamsHandling: 'merge',
      };
      await this.router.navigate([], query);
    }
  }
}
